import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IActionErrorInfo } from "../../jobs/types/IActionErrorInfo";
import { deleteTicketGrid } from "../thunks/deleteTicketGrid";
import { ITicketGridsState } from "../types/ITicketGridsState";

function removeLoadingKey(key: string, state: ITicketGridsState) {
  state.loadingReportKeys = state.loadingReportKeys.filter((id) => id != key);
}

export const addDeleteTicketGrid = (
  builder: ActionReducerMapBuilder<ITicketGridsState>,
) => {
  builder.addCase(deleteTicketGrid.pending, (state, action) => {
    state.loadingReportKeys = [
      ...state.loadingReportKeys,
      `${action.meta.arg.id}`,
    ];
  });
  builder.addCase(deleteTicketGrid.rejected, (state, action) => {
    removeLoadingKey(`${action.meta.arg.id}`, state);
    const error: IActionErrorInfo = {
      id: Date.now(),
      message: `Ошибка удаления шаблона/задачи ID: ${action.meta.arg.id}!: ${action.error.message}`,
    };
    state.errors = state.errors ? [...state.errors, error] : [error];
  });
  builder.addCase(deleteTicketGrid.fulfilled, (state, action) => {
    removeLoadingKey(`${action.meta.arg.id}`, state);
    state.templates = state.templates.filter(
      (j) => j.id !== action.meta.arg.id,
    );
    state.childTemplates = state.childTemplates.filter(
      (j) => j.id !== action.meta.arg.id,
    );
  });
};
